export default {
    action: 'Create',
    microtrend: 'Micro-trend',
    macrotrend: 'Macro-trend',
    megatrend: 'Mega-trend',
    workspace: 'Work space',
    trendradar: 'Trend radar',
    innovationField: 'Innovation field',
    innovationProject: 'Innovation project'
}
